const initStickyNav = () => {
    const navbar = document.querySelector(".js-sticky-services");
    if (!navbar) return;

    const linksArray = Array.from(navbar.querySelectorAll("a.js-service-item")); // Convert NodeList to Array
    const validLinks = []; // Array to hold valid links
    const targets = [];

    linksArray.forEach(link => {
        let href = link.getAttribute("href");
        let targetEl = document.querySelector(href);
        if (!targetEl) {
            link.parentNode.removeChild(link);
            console.error(`Kotva ${href} neexistuje`);
        } else {
            validLinks.push(link); // Add to valid links array
            targets.push(targetEl)
        }
    });


    function updateActiveBoxClass(validLinks, index) {
        const currentLinkParent = validLinks[index].closest('.js-service-catbox');


        // Check if the current parent has the 'is-active-box' class
        if (!currentLinkParent.classList.contains('is-active-box')) {

            // If not, first remove 'is-active-box' from all '.js-service-catbox' elements
            const catBoxes = document.querySelectorAll('.js-service-catbox');
            catBoxes.forEach(catBox => {
                catBox.classList.remove('is-active-box');
            });

            // Then add 'is-active-box' to the parent of the current link
            currentLinkParent.classList.add('is-active-box');

        }
    }


    const observerOptions = {
        root: null,  // Use the viewport
        rootMargin: '-45% 0% -45% 0%',  // No margins
        threshold: 0  // At least half the SVG should be visible
    };

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                const index = targets.indexOf(entry.target);

                // Log the intersecting target
                //console.log("Intersecting Target:", entry.target);

                for (const link of validLinks) {
                    link.classList.remove('is-active');
                }

                validLinks[index].classList.add('is-active');
                // Update the 'is-active-box' class for the parent box
                updateActiveBoxClass(validLinks, index);
                break;
            }
        }
    }, observerOptions);

    targets.forEach(

        target => { observer.observe(target); });
};

export { initStickyNav };
